/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'confluence.error.panel.refresh.app': 'Обновить приложение',
  'confluence.error.panel.reload.page': 'Перезагрузить страницу',
  'confluence.icon.label': 'Значок',
  'confluence.modal.dialog.close.modal.button': 'Отмена',
  'confluence.select.required.field.message': 'Это обязательное поле.',
  'confluence.text.area.required.field.message': 'Это обязательное поле.',
  'confluence.textfield.validator.email': 'Введите действительный адрес электронной почты.',
  'confluence.textfield.validator.number': 'Укажите допустимое значение',
  'confluence.textfield.validator.required.field.message': 'Это обязательное поле.',
  'confluence.textfield.validator.telephone': 'Введите действительный номер телефона.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Требуется доступ',
  'confluence.threeLOPrompt.modal.error.title': 'Ошибка',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Одобренный URL-адрес не найден. Обновите страницу и повторите попытку.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Одобренный URL-адрес не найден. Обновите страницу и повторите попытку.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Предоставить доступ',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Настроить доступ',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Ошибка аутентификации.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Чтобы отобразить {appString}, разрешите приложению доступ к продуктам Atlassian от вашего имени.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message-appify':
    'Чтобы приложение {appString} отображалось, необходимо разрешить ему доступ к приложениям Atlassian от вашего имени.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} требует дополнительный доступ к вашему аккаунту.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Предупреждение о внешней аутентификации',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'это приложение',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Это приложение',
  'confluence.user.group.unknown.user.message': 'Неизвестный пользователь',
  'confluence.user.picker.empty.field.error.message': 'Это обязательное поле.',
  'confluence.user.unknown.user.message': 'Неизвестный пользователь',
  'forge-ui.form.submit-button.text': 'Отправить',
  'forge.modal.deprecation.message':
    'В приложении {appName} используется устаревший модальный интерфейс редактирования пользовательских полей, поддержка которого прекращается. Попросите системного администратора обновить приложение, чтобы вы могли пользоваться возможностью встроенного редактирования. Если проблемы не исчезнут, обратитесь к разработчику приложения.',
  'forge.modal.deprecation.title': 'Обновите приложение',
};
